<template>
  <!--  欢银电影 订单确认-->
  <div class='order'>
    <div class='card'>
      <div class='up'>
        <div class='div-img'>
          <img src='@/assets/img/film.png' alt='' />
        </div>
        <div class='rg'>
          <div>{{ filmName }}</div>
          <div>{{ cinemaName }}</div>
        </div>
      </div>
    </div>
    <div class='det'>
      <div class='add'>
        <div>单张票价</div>
        <div>¥ {{ ticketPrice }}</div>
      </div>
      <van-divider />
      <div class='add'>
        <div>票数</div>
        <div>{{ ticketNum }} 张</div>
      </div>
      <van-divider />
      <!--      <div class='add'>-->
      <!--        <div>取票手机号</div>-->
      <!--        <div>{{ ticketMobile }}</div>-->
      <!--      </div>-->
      <!--      <van-divider />-->
      <div class='add'>
        <div>服务费</div>
        <div>¥ {{ serviceFeeMoney }}</div>
      </div>
      <van-divider />
      <div class='add'>
        <div>金额合计</div>
        <div class='rgt'>
          ¥ {{ orderMoney }}
        </div>
      </div>
    </div>
    <div class='note'>* 每张票收取1块钱手续费</div>
    <div class='note' style='margin-top: 0.1rem'>* 超过15分钟将自动关单，请及时支付</div>
    <div class='foot'>
      <div class='pri'>
        <div class='lf'>
          <span>合计：</span>
        </div>
        <div class='rg'>
          ¥{{ zs }}<span>.{{ xs }}</span>
        </div>
      </div>
      <div class='btn' @click='confirmPay'>
        确认支付
      </div>
    </div>
  </div>
</template>

<script>
import { getFilmOrderDetail, getFilmPayInfo } from '@/api/floor'

export default {
  data () {
    return {
      orderId: '', // 订单id
      filmName: '', // 影片名称
      cinemaName: '', // 影院名称
      ticketPrice: '', // 单张票价（元）
      ticketNum: '', // 票数
      ticketMobile: '', // 取票手机号
      serviceFeeMoney: '', // 服务费（元）
      orderMoney: '', // 订单金额（元）
      zs: '',
      xs: ''
    }
  },
  created () {
    this.orderId = this.$route.query.orderId ? this.$route.query.orderId : ''
    this.getDetail()
  },
  mounted: {},
  methods: {
    // 获取订单详情
    getDetail () {
      getFilmOrderDetail({
        orderId: this.orderId
      }).then(res => {
        if (res.code === 200) {
          this.filmName = res.data.filmName
          this.cinemaName = res.data.cinemaName
          this.ticketPrice = res.data.ticketPrice
          this.ticketNum = res.data.ticketNum
          this.ticketMobile = res.data.ticketMobile
          this.serviceFeeMoney = res.data.serviceFeeMoney
          this.orderMoney = res.data.orderMoney

          // 设置金额格式
          if (this.orderMoney.toString().indexOf('.') !== -1) {
            this.zs = this.orderMoney.toString().split('.')[0]
            this.xs = this.orderMoney.toString().split('.')[1]
          } else {
            this.zs = this.orderMoney
            this.xs = '00'
          }
        }
      })
    },
    // 确认支付
    confirmPay () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      getFilmPayInfo({
        orderId: this.orderId
      })
        .then(res => {
          this.$toast.clear()
          if (res.code === 200) {
            // 支付链接
            location.href = res.data.payUrl
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.order {
  text-align: left;
  padding: 0.15rem;
  background-color: #f6f6f6;
  padding-bottom: 0.55rem;

  .card {
    width: 3.45rem;
    background: #ffffff;
    border-radius: 0.04rem;
    box-shadow: 0px 0.01rem 0.02rem 0px rgba(192, 192, 192, 0.08);
    padding: 0.15rem;
    box-sizing: border-box;

    .up {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .div-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.675rem;
        height: 0.675rem;

        img {
          width: 0.43rem;
          height: 0.43rem;
          border-radius: 0.08rem;
        }
      }

      .rg {
        padding: 0.08rem 0;
        margin-left: 0.2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        div:first-child {
          font-size: 0.17rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          text-align: left;
          color: #333333;
          line-height: 0.185rem;
        }

        div:nth-child(2) {
          font-size: 0.17rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          // color: #999999;
          color: #333333;
          line-height: 0.185rem;
          margin-top: 0.15rem;
        }

        // div:last-child {
        //   font-size: 0.14rem;
        //   font-family: PingFangSC, PingFangSC-Regular;
        //   font-weight: 600;
        //   text-align: left;
        //   color: #333333;
        //   line-height: 0.185rem;
        // }
      }
    }

    .down {
      margin-top: 0.15rem;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #e90a0a;
      line-height: 0.165rem;
    }
  }

  .det {
    margin-top: 0.15rem;
    width: 3.45rem;
    background: #ffffff;
    border-radius: 0.04rem;
    box-shadow: 0px 0.01rem 0.02rem 0px rgba(192, 192, 192, 0.08);
    padding-left: 0.2rem;
    padding-right: 0.15rem;
    box-sizing: border-box;

    ::v-deep .van-divider {
      margin: 0 0;
      font-size: 0;
      line-height: 0.5px;
    }

    .add {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.48rem;
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 0.48rem;

      div:last-child {
        color: #333333;
        font-weight: 600;
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Medium;
        line-height: 0.185rem;
        text-align: left;
      }

      div:last-child.rgt {
        color: #e90a0a;
      }
    }
  }

  .xz {
    margin-top: 0.15rem;
    // height: 0.185rem;
    margin-left: 0.1rem;

    ::v-deep .van-checkbox__icon {
      font-size: 0.16rem;
      margin-right: 0.1rem;
      background: #fff;

      .van-icon-success {
        border: 0.01rem solid #b8b8b8;
      }
    }

    ::v-deep .van-checkbox__label {
      font-size: 0.14rem;
      margin-left: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-decoration: underline;
      text-align: left;
      color: #333;
    }
  }

  .note {
    margin-top: 0.15rem;
    margin-left: 0.15rem;
    font-size: 0.12rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #e90a0a;
  }

  .foot {
    width: 3.75rem;
    height: 0.6rem;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0.1rem 0.15rem;
    background: #ffffff;
    box-shadow: 0.01rem 0px 0.02rem 0.01rem rgba(0, 0, 0, 0.04);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .pri {
      display: flex;
      align-items: flex-end;

      .lf {
        margin-bottom: 0.05rem;
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 0.165rem;

        span {
          color: #333;
        }
      }

      .rg {
        font-size: 0.21rem;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        color: #e90a0a;
        line-height: 0.3rem;
        letter-spacing: 0.0056rem;
        vertical-align: bottom;

        span {
          font-size: 0.18rem;
        }
      }
    }

    .btn {
      width: 0.95rem;
      height: 0.35rem;
      background-image: linear-gradient(53deg, #f46264 0%, #fb8606 100%);
      border-radius: 0.175rem;
      background-size: contain;
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 0.35rem;
    }
  }
}
</style>
